// extracted by mini-css-extract-plugin
module.exports = {"main":"SelectBox_main__2fb1x","label":"SelectBox_label__1bhKt"};